// extracted by mini-css-extract-plugin
export default {"title":"yoa-z","warning":"zoa-z","sizeOptionsLegendText":"Aoa-z"};